import { render, staticRenderFns } from "./ManagerDashboard3.vue?vue&type=template&id=b30a968c&scoped=true&"
import script from "./ManagerDashboard3.vue?vue&type=script&lang=js&"
export * from "./ManagerDashboard3.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashboard3.vue?vue&type=style&index=0&id=b30a968c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30a968c",
  null
  
)

export default component.exports